<template>
  <div>相册管理</div>
</template>

<script>
export default {

}
</script>

<style>

</style>